(function () {
    window.teamBattleService = {
        getQueue(data) {
            //return axios.get(`/api/battle/get.php${ data && data.battle ? '?active=true' : ''}`);
            return axios.get(`/api/team_battle/get_queue.php?twitchId=${utils.cookies.get('user_id')}`, data);
        },
        getStreamerQueue(data) {
            return axios.get(`/api/team_battle/get_queue.php?streamer=true&&twitchId=${utils.cookies.get('user_id')}`);
        },
        getActive(data) {
            return axios.get(`/api/team_battle/get.php?active=true`);
        },
        getAuto(data) {
            return axios.get(`/api/team_battle/get.php?auto=true`);
        },
        getStatus(id) {
            return axios.get(`/api/team_battle/status.php?id=${id}`);
        },
        challenge(data) {
            return axios.post('/api/team_battle/challenge.php', {
            user1TwitchId: data.fromId,
            user1TwitchDisplayName: data.fromUserName,
            opponent: data.opponent,
            team: data.team,
            user1Cards: data.cards,
            count: data.count,
            faction: data.faction,
            teamName: data.teamName,
            createTeam: data.createTeam,
            teamChallenge : true
            });
        },
        accept(data) {
            return axios.post('/api/team_battle/accept.php', {
            user1TwitchDisplayName: data.atName,
            user2TwitchDisplayName: data.fromUserName,
            user2TwitchId: data.fromId,
            user2Cards: data.cards,
            faction: data.faction,
            teamName: data.teamName,
            });
        },
        isTeamBattleEnabled(data){
            return axios.post('/api/team_battle/checkteamplayenabled.php', {
                request_count : data.count
            })
        },
        save(data) {
            return axios.post('/api/team_battle/save.php', data);
        },
        decline(data) {
            return axios.post('/api/team_battle/decline.php', {
              user1TwitchDisplayName: data.atName,
              user2TwitchDisplayName: data.fromUserName,
            });
        },
        cancel(data) {
        return axios.post('/api/team_battle/cancel.php', data);
        },
        startStreamerBattle(id){
            const data = {
                id: id,
                start_battle: true
            }
            return axios.post(`/api/streamer/save.php`, data);
        },
        requeue(data){
            return axios.post('/api/team_battle/queue.php', data);
        }
    };
  })();
  